import React, { useEffect, useState } from "react";
import api from '../../../components/api'
import { onlyNumberWithDecimal, onlyNumberWithTwoDecimal } from '../../../components/functions'
import InputMask from 'react-input-mask'

import { useEnergiaRefrigeracaoContext } from '../../../context/energiaRefrigeracaoUnitContext'
import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {

    const energia_id = props.energia_id
    const ano = props.ano
    const adesao_institucional_id = props.adesao_institucional_id

    const { setAtualizacaoGestao } = useTabelaGestao()

    const { energiaRefrigeracao_id, setEnergiaRefrigeracao_id } = useEnergiaRefrigeracaoContext()

    const [tipo, setTipo] = useState('')
    const [marca, setMarca] = useState('')
    const [modelo, setModelo] = useState('')
    const [volume, setVolume] = useState('')
    const [anoFabricacao, setAnoFabricacao] = useState('')
    const [quantidade, setQuantidade] = useState('')
    const [potenciaEletrica, setPotenciaEletrica] = useState('')
    const [consumoEtiqueta, setConsumoEtiqueta] = useState('')
    const [nivelEtiqueta, setNivelEtiqueta] = useState('')
    const [fluidoRefrigerante, setFluidoRefrigerante] = useState('')
    //const [ambiente, setAmbiente] = useState('')
    const [entradaOperacao, setEntradaOperacao] = useState('')
    const [saidaOperacao, setSaidaOperacao] = useState('')

    //const [energiaRefrigeracao_id, setEnergiaRefrigeracao_id] = useState()

    const [resultadoRefrigeracao, setResultadoRefrigeracao] = useState()
    const [resultadoRefrigeracaoCamaraFria, setResultadoRefrigeracaoCamaraFria] = useState()

    const [energiaAmbiente_id, setEnergiaAmbiente_id] = useState()
    const [resultadoAmbientes, setResultadoAmbientes] = useState()

    const [resultadoFluidoRefrigerante, setResultadoFluidoRefrigerante] = useState()

    const [listaAnos, setListaAnos] = useState()
    const [energiaRefrigeracaoMarcaLista, setEnergiaRefrigeracaoMarcaLista] = useState()

    


    function carregaAnos() {

        var x_array = []

        for (var x = 1990; x <= 2030; x++) {
            
            x_array.push(x)

        }


        //console.log(x_array, 'aqui')
        setListaAnos(x_array.sort().reverse().map((ano) =>
        
            <option value={ano}>{ano}</option>
        
        ))
        

    }


    function limpaDados() {

        setTipo('')
        setMarca('')
        setModelo('')
        setVolume('')
        setAnoFabricacao('')
        setQuantidade('')
        setPotenciaEletrica('')
        setConsumoEtiqueta('')
        setNivelEtiqueta('')
        setFluidoRefrigerante('')
        //setAmbiente('')
        setEnergiaAmbiente_id()
        setResultadoAmbientes()
        setEntradaOperacao('')
        setSaidaOperacao('')

    }


    function carregaMarca() {


        api.get(`energiaRefrigeracaoMarcaListaTodos`).then((result) => {

            //console.log(result.data, '??')

            setEnergiaRefrigeracaoMarcaLista(result.data.map((rs) =>

                <option value={rs.descricao} key={rs.energiaRefrigeracaoMarca_id}>{rs.descricao}</option>
            
            ))


        }).catch((err) => {

            console.log(err.response)

        })


    }


    function consultaFluidoRefrigerante() {

        api.get('fluidoRefrigeranteListaTodos').then((result) => {

            //console.log(result.data)

            setResultadoFluidoRefrigerante(result.data.map((rs) =>
            
                <option key={rs.fluidoRefrigerante_id} value={rs.descricao}>{rs.descricao}</option>
            
            ))


        }).catch((err) => {

            console.log(err.response)

        })

    }

    function carregaAmbientes() {

        if (energia_id) {

            api.get(`energiaAmbienteLista/${energia_id}`).then((result) => {

                //console.log(result.data)
                setResultadoAmbientes(result.data.map((rs) =>

                    <option value={rs.energiaAmbiente_id} key={rs.energiaAmbiente_id}>{rs.identificacao}</option>
                
                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }

    }


    function consultaRefrigeracaoDet() {

        
        if (energiaRefrigeracao_id) {

            api.get(`energiaRefrigeracaoListaUm/${energiaRefrigeracao_id}`).then((result) => {

                ////console.log(result.data)

                var data = result.data[0]

                setTipo(data.tipo)
                setMarca(data.marca)
                setModelo(data.modelo)
                setVolume(data.volume == null ? '' : data.volume.toString())
                setAnoFabricacao(data.anoFabricacao == null ? '' : data.anoFabricacao.toString())
                setQuantidade(data.quantidade == null ? '' : data.quantidade.toString())
                setPotenciaEletrica(data.potenciaEletrica == null ? '' : data.potenciaEletrica.toString())
                setConsumoEtiqueta(data.consumoEtiqueta == null ? '' : data.consumoEtiqueta.toString())
                setNivelEtiqueta(data.nivelEtiqueta)
                setFluidoRefrigerante(data.fluidoRefrigerante)
                setEnergiaAmbiente_id(data.energiaAmbiente_id)
                setEntradaOperacao(data.entradaOperacao)
                setSaidaOperacao(data.saidaOperacao)

            }).catch((err) => {

                console.log(err.response)

            })

        }

        

    }



    function salva() {


        if (tipo == '') {

            window.toastr.error('<b>Tipo</b> não pode ficar em branco!')
            return false

        }

        if (marca == '') {

            //window.toastr.error('<b>Marca</b> não pode ficar em branco!')
            //return false

        }

        if (modelo == '') {

            //window.toastr.error('<b>Modelo</b> não pode ficar em branco!')
            //return false

        }



        /*

        if (volume == '') {

            window.toastr.error('<b>Volume</b> não pode ficar em branco!')
            return false

        } else {

            if (volume == '0') {

                window.toastr.error('<b>Volume</b> não pode ser igual a zero!')
                return false

            }

        }
        */


        if (anoFabricacao == '') {

            window.toastr.error('<b>Ano de fabricação</b> não pode ficar em branco!')
            return false

        }


        if (quantidade == '') {

            window.toastr.error('<b>Quantidade</b> não pode ficar em branco!')
            return false

        } else {

            if (quantidade == '0') {

                window.toastr.error('<b>Quantidade</b> não pode ser igual a zero!')
                return false

            }

        }


        /*
        if (potenciaEletrica == '') {

            window.toastr.error('<b>Potência Elétrica Média</b> não pode ficar em branco!')
            return false

        }  else {

            if (potenciaEletrica == '0') {

                window.toastr.error('<b>Potência Elétrica</b> não pode ser igual a zero!')
                return false

            }

        }
        */

        if (consumoEtiqueta == '') {

            window.toastr.error('<b>Consumo Etiqueta</b> não pode ficar em branco!')
            return false
            
        } else {

            if (consumoEtiqueta == '0') {

                window.toastr.error('<b>Consumo Etiqueta</b> não pode ser igual a zero!')
                return false

            }

        }

        /*
        if (nivelEtiqueta == '') {

            window.toastr.error('<b>Nível Etiqueta</b> não pode ficar em branco!')
            return false

        }
        */



        if (entradaOperacao != '') {


            if (entradaOperacao.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Entrada em Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = entradaOperacao.split('/')
                var mesEntradaOperacao = x_array[0]

                

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Entrada em Operação</b>!')
                    return false
    
                }  else {

                    var dataEntradaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')

                }


                if (anoFabricacao != '' && x_array[1] != '') {

                    var anoFabricacao_r = parseInt(anoFabricacao)

                    var anoEntradaOperacao = parseInt(x_array[1])

                    if (anoEntradaOperacao < anoFabricacao_r) {


                        window.toastr.error('O <b>Ano de entrada em operação</b> não pode ser anterior que o <b>ano de fabricação</b>!')
                        return false


                    }

                }


            }
            

        }


        if (saidaOperacao != '') {


            if (saidaOperacao.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Saída de Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = saidaOperacao.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Saída de Operação</b>!')
                    return false
    
                }


                if (anoEntradaOperacao != '' && x_array[1] != '' && x_array[0] != '' && mesEntradaOperacao != '') {
                
                    var anoSaidaOperacao = parseInt(x_array[1])
                    var mesSaidaOperacao = parseInt(x_array[0])

                    if (anoSaidaOperacao < anoEntradaOperacao) {

                        window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                        return false

                    } else {

                        var dataSaidaTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')
                        //console.log(dataEntradaTemp, dataSaidaTemp)

                        //console.log('aqui..')

                        if (dataSaidaTemp < dataEntradaTemp) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }

                        /*
                        if (mesSaidaOperacao < parseInt(mesEntradaOperacao)) {

                            window.toastr.error('Data de saída de operação precisa ser posterior a data de enetrada em operação!')
                            return false

                        }
                        */


                    }


                }


            }
            

        }


        var dataPost = {

            energia_id: energia_id,
            ano: ano,
            adesao_institucional_id: adesao_institucional_id,
            tipo: tipo,
            marca: marca,
            modelo: modelo,
            volume: volume,
            anoFabricacao: anoFabricacao,
            quantidade: quantidade,
            potenciaEletrica: potenciaEletrica,
            consumoEtiqueta: consumoEtiqueta,
            nivelEtiqueta: nivelEtiqueta,
            fluidoRefrigerante: fluidoRefrigerante,
            //ambiente: ambiente,
            energiaAmbiente_id: energiaAmbiente_id,
            entradaOperacao: entradaOperacao,
            saidaOperacao: saidaOperacao,

        }

        console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (energiaRefrigeracao_id) {

                        //console.log('put')

                        api.put(`energiaRefrigeracao/${energiaRefrigeracao_id}`, dataPost).then((result) => {
    
                            //setShow(false)
                            //consultaRefrigeracao()
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalRefrigeracaoUnitario').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })


                    } else {

                        api.post('energiaRefrigeracao', dataPost).then((result) => {

                            console.log(result.data)
                            //setShow(false)
                            //consultaRefrigeracao()
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalRefrigeracaoUnitario').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))

    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                    
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }


    function apagaRefrigeracao() {

        if (energiaRefrigeracao_id) {

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaRefrigeracao/${energiaRefrigeracao_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow(false)
                            //consultaRefrigeracao()
                            //window.toastr.sucess('Registro apagado com sucesso')

                            window.$('#modalRefrigeracaoUnitario').modal('hide')
                            window.toastr.success('Registro salvo com sucesso!')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }

    }


    useEffect(() => {

        limpaDados()
        carregaAnos()
        carregaMarca()
        consultaFluidoRefrigerante()
        carregaAmbientes()
        consultaRefrigeracaoDet()

    }, [energiaRefrigeracao_id])


    const handleChange = (e) => {
        e.preventDefault();
    }


    return (

        <div>

                <div className="modal fade" id="modalRefrigeracaoUnitario" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Refrigeração - Equipamento Unitário</h1>
                            </div>
                            <div className="modal-body">


                                <div className="row">



                                <div className="col-md-12" >
                                    <b>Dados básicos</b>
                                    <br/><br/>
                                </div>
                                    
                                    
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Tipo *</label>
                                            <select class="form-control" value={tipo} onChange={event => setTipo(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value="Câmara de Conservação">Câmara de Conservação</option>
                                                <option value="Expositor Horizontal">Expositor Horizontal</option>
                                                <option value="Expositor Vertical">Expositor Vertical</option>
                                                <option value="Freezer de Vacinas">Freezer de Vacinas</option>
                                                <option value="Freezer Horizontal">Freezer Horizontal</option>
                                                <option value="Freezer Vertical">Freezer Vertical</option>
                                                <option value="Frigobar">Frigobar</option>
                                                <option value="Geladeira">Geladeira</option>
                                                <option value="Outros">Outros</option>
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Marca *</label>
                                            <select className="form-control" value={marca} onChange={event => setMarca(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value="Não informado">Não informado</option>
                                                {energiaRefrigeracaoMarcaLista}
                                                
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                            
                                            <label className="control-label">Modelo</label>
                                            <input class="form-control" input="text" value={modelo} onChange={event => setModelo(event.target.value)} />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Volume [l]</label>
                                            <input class="form-control" input="text" value={volume} onChange={event => setVolume(event.target.value)} 
                                            onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Ano de Fabricação *</label>
                                            <select class="form-control" value={anoFabricacao} onChange={event => setAnoFabricacao(event.target.value)} >
                                                <option value="">[Selecione]</option>
                                                {listaAnos}
                                                <option value="0">Não informado</option>

                                            </select>
                                            
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-3" >
                                        <div class="form-group" >
                                        <br/>
                                            <label className="control-label">Quantidade *</label>
                                            <input class="form-control" input="text" value={quantidade} onChange={event => setQuantidade(event.target.value)} 
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                                }
                                            }} 
                                            />
                                                
                                        </div>
                                    </div>
                                

                                    <div className="col-md-12" >
                                        <br/><br/>
                                        <b>Dados Técnicos</b>
                                        <br/><br/>
                                    </div>
                                        
                                        
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                            
                                                <label className="control-label">Potência Elétrica Média [W]</label>
                                                <input class="form-control" input="text" value={potenciaEletrica} onChange={event => setPotenciaEletrica(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                            
                                                <label className="control-label">Consumo Etiqueta [kWh/mês] *</label>
                                                <input class="form-control" input="text" value={consumoEtiqueta} onChange={event => setConsumoEtiqueta(event.target.value)} 
                                                onKeyPress={(e)=>onlyNumberWithDecimal(e)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Nível Etiqueta</label>
                                                <select class="form-control" value={nivelEtiqueta} onChange={event => setNivelEtiqueta(event.target.value)} >
                                                    <option value="">[Selecione]</option>    
                                                    <option value="A+++">A+++</option>
                                                    <option value="A++">A++</option>
                                                    <option value="A+">A+</option>
                                                    <option value="A">A</option>
                                                    <option value="B">B</option>
                                                    <option value="C">C</option>
                                                    <option value="D">D</option>
                                                    <option value="E">E</option>
                                                </select>
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Fluído Refrigerante</label>
                                                <select class="form-control" value={fluidoRefrigerante} onChange={event => setFluidoRefrigerante(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    {resultadoFluidoRefrigerante}
                                                </select>
                                                    
                                            </div>
                                        </div>

                                        


                                        <div className="col-md-12" >
                                            <br/><br/>
                                            <b>Dados Operacionais</b>
                                            <br/><br/>
                                        </div>
                                            
                                            
                                            <div className="col-md-12" >
                                                <div class="form-group" >
                                                
                                                    <label className="control-label">Ambiente</label>
                                                    <select class="form-control" value={energiaAmbiente_id} onChange={event => setEnergiaAmbiente_id(event.target.value)}>
                                                        <option value="">[Selecione]</option>
                                                        {resultadoAmbientes}
                                                    </select>
                                                        
                                                </div>
                                            </div>
                                        
                                            <div className="col-md-6" >
                                                <div class="form-group" >
                                                    <br/>
                                                    <label className="control-label">

                                                        <span class="wrapper2">
                                                            Entrada em operação (Mês/Ano)
                                                            <div class="tooltip">
                                                            insira a data (mês e ano) quando o equipamento entrou em operação na unidade.

                                                            </div>
                                                        </span>

                                                    </label>
                                                    
                                                    
                                                    <InputMask mask="99/9999" placeholder="MM/AAAA" class="form-control" value={entradaOperacao} onChange={event => setEntradaOperacao(event.target.value)} />
                                                        
                                                </div>
                                            </div>
                                            <div className="col-md-6" >
                                                <div class="form-group" >
                                                    <br/>
                                                    <label className="control-label">

                                                        <span class="wrapper2">
                                                            Saída de operação (Mês/Ano)
                                                            <div class="tooltip">
                                                            insira a data (mês e ano) quando o equipamento saiu de operação na unidade.

                                                            </div>
                                                        </span>

                                                    </label>
                                                    
                                                    <InputMask mask="99/9999" placeholder="MM/AAAA" class="form-control" value={saidaOperacao} onChange={event => setSaidaOperacao(event.target.value)} />
                                                        
                                                </div>
                                            </div>

                                    

                                
                                    

                                </div>




                            </div>
                            <div className="modal-footer">

                                            
                                <button type="button" className="btn btn-danger" onClick={() => apagaRefrigeracao()} style={{ display: energiaRefrigeracao_id ? 'table-row' : 'none'}}>Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal